import { Grid } from '@mui/material';

import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';

import StyledDropzone from 'app/components/Dropzone';
import { translations } from 'locales/i18n';

export default function CompanyDescription() {
  const { errors, setFieldValue, values }: any = useFormikContext<any>();
  const { t } = useTranslation();

  return (
    <>
      <Grid container className="register-form__description">
        {t(translations.pages.login.formDescriptions.companyDescription())}
      </Grid>
      <Grid container>
        <Field
          name="description"
          error={errors.description}
          helperText={errors.description}
          theme="snow"
        >
          {({ field }) => (
            <ReactQuill
              className="register-form__rte"
              value={field.value}
              onChange={field.onChange(field.name)}
              theme="snow"
              modules={{
                toolbar: [
                  ['bold', 'italic'],
                  [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
                  ['clean']
                ],
                clipboard: {
                  allowed: {
                    tags: ['a', 'b', 'strong', 'u', 's', 'i', 'p', 'br', 'ul', 'ol', 'li', 'span'],
                    attributes: ['href', 'rel', 'target', 'class']
                  },
                  keepSelection: true,
                  substituteBlockElements: true,
                  magicPasteLinks: true,
                  matchVisual: false
                }
              }}
              formats={[
                'header',
                'bold',
                'italic',
                'align',
                'size',
                'font',
                'color',
                'underline',
                'strike',
                'blockquote',
                'list',
                'bullet',
                'indent',
                'link',
                'image'
              ]}
            />
          )}
        </Field>
        <Grid container>
          <div style={{ marginTop: '1em', width: '100%' }}>
            <StyledDropzone
              name="companyData.logo"
              setFieldValue={setFieldValue}
              value={values.companyData.logo}
              errors={errors}
              accept={{
                'image/jpeg': ['.jfif', '.jfif-tbnl', '.jpe', '.jpeg', '.jpg'],
                'image/png': ['.png', '.x-png'],
                'image/svg+xml': ['.svg']
              }}
              placeholder={t(translations.pages.manageCompanies.logoUploadPlaceholder())}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
}
